import React from 'react'
import PropTypes from 'prop-types'
// import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import CustomModal from 'components/common/modal/CustomModal'

// import moment from 'moment'

function AttendanceModal({ handleCloseModal, selectedAttendance }) {
  console.log('selectedddddd', selectedAttendance)
  return (
    <CustomModal
      size='md'
      show
      onHide={handleCloseModal}
      heading='Attendee status'
    >
      <div className='container-fluid'>
        {/* <TableWrapper> */}
        <table className='table table-main'>
          <thead>
            <tr>
              <th scope='col'>
                <div className='header-text-otr'>
                  <p
                    className='table-name heading-xsb'
                    aria-label='User index Column'
                  >
                    #
                  </p>
                </div>
              </th>
              <th scope='col'>
                <div className='header-text-otr'>
                  <p
                    className='table-name heading-xsb'
                    aria-label='User Name Column'
                  >
                    Date
                  </p>
                </div>
              </th>
              <th scope='col'>
                <div className='header-text-otr'>
                  <p
                    className='table-name heading-xsb'
                    aria-label='User Name Column'
                  >
                    Status
                  </p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {selectedAttendance?.map((item, index) => (
              <tr key={item.id}>
                <th scope='col'>
                  <div className='header-text-otr'>
                    <p
                      className='table-name heading-xsb'
                      aria-label='User Table Data Column'
                    >
                      {index + 1}
                    </p>
                  </div>
                </th>
                <td>
                  <div className='table-text-otr'>
                    <p className='table-text-black' title={item.date}>
                      {item.date ?? 'N/A'}
                    </p>
                  </div>
                </td>

                <td>
                  <div className='table-text-otr'>
                    <p className='table-text-black' title={item.visit}>
                      {item.visit === false ? 'Not attended' : 'Attended'}
                    </p>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* )} */}
        {/* </TableWrapper> */}
        <div className='col-md-12 d-flex justify-content-end gap-4 mt-2'>
          <button
            type='button'
            className='secondary-btn record-btn'
            onClick={handleCloseModal}
          >
            Cancel
          </button>
          <button type='submit' className='primary-btn record-btn'>
            Save
          </button>
        </div>
      </div>
    </CustomModal>
  )
}

AttendanceModal.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  selectedAttendance: PropTypes.arrayOf(
    PropTypes.shape({
      // _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      date: PropTypes.string,
      visit: PropTypes.bool,
    })
  ).isRequired,
}

export default AttendanceModal
